import React from 'react';

export const insuranceLanguageContent = {
    'insurance': {
        'en': 'Health Insurance',
        'ar': 'تأمين صحي',
        'ht': 'Asirans Sante',
        'pl': 'Ubezpieczenie zdrowotne',
        'pt': 'Plano de saúde',
        'sr': 'Здравствено осигурање',
        'es': 'Seguro de salud',
        'vi': 'Bảo hiểm y tế',
        'zh': '健康保险',
        'ne': 'स्वास्थ्य बिमा'
    },
    'insurance-question-1': {
        'en': <span>Does the Patient have <b className='font-semibold'>Health Insurance?</b></span>,
        'ar': <span className='dir-rtl'>هل يتمتع المريض <b className='font-semibold'>بالتأمين الصحي؟</b></span>,
        'ht': <span>Èske Pasyan an gen <b className='font-semibold'>Asirans Sante?</b></span>,
        'pl': <span>Czy Pacjent posiada <b className='font-semibold'>ubezpieczenie zdrowotne?</b></span>,
        'pt': <span>O paciente tem <b className='font-semibold'>seguro saúde?</b></span>,
        'sr': <span>Да ли пацијент има <b className='font-semibold'>здравствено осигурање?</b></span>,
        'es': <span> ¿El paciente tiene <b className='font-semibold'> seguro de salud? </b> </span>,
        'vi': <span>Bệnh nhân có <b className='font-semibold'>Bảo hiểm y tế không?</b></span>,
        'zh': <span>患者是否有<b className='font-semibold'>健康保险？</b></span>,
        'ne': <span>के बिरामीसँग <b className='font-semibold'>स्वास्थ्य बीमा छ?</b></span>
    },
    'insurance-question-2': {
        'en': <span >Is the Patient covered by more than (1) insurance plan?</span>,
        'ar': <span >هل المريض مشمول بأكثر من (1) خطة تأمين؟</span>,
        'ht': <span >Èske Pasyan an kouvri pa plis pase (1) plan asirans?</span>,
        'pl': <span >Czy Pacjent jest objęty więcej niż (1) planem ubezpieczenia?</span>,
        'pt': <span >O paciente está coberto por mais de (1) plano de seguro?</span>,
        'sr': <span >Да ли је пацијент покривен са више од (1) плана осигурања?</span>,
        'es': <span >¿Está el paciente cubierto por más de (1) plan de seguro?</span>,
        'vi': <span >Bệnh nhân có được bảo hiểm bởi nhiều hơn (1) chương trình bảo hiểm không?</span>,
        'zh': <span>患者是否拥有超过 (1) 个保险计划？</span>,
        'ne': <span>के बिरामी (१) भन्दा बढी बीमा योजनाद्वारा कभर गरिएको छ?</span>
    },
    'insurance-question-3': {
        'en': <span>Is the Patient also the <b>policy holder?</b></span>,
        'ar': <span>هل المريض هو أيضًا <b>صاحب البوليصة؟</b></span>,
        'ht': <span>Èske Pasyan an <b>titulè politik la tou?</b></span>,
        'pl': <span>Czy Pacjent jest również <b>posiadaczem polisy?</b></span>,
        'pt': <span>O paciente também é o <b>titular da apólice?</b></span>,
        'sr': <span>Да ли је пацијент такође <b>носилац полисе?</b></span>,
        'es': <span> ¿Es el paciente también el <b> titular de la póliza? </b> </span>,
        'vi': <span>Bệnh nhân cũng là <b>người nắm giữ hợp đồng?</b></span>,
        'zh': <span>患者也是<b>保单持有人吗？</b></span>,
        'ne': <span>के बिरामी पनि <b>नीति धारक हो?</b></span>
    },
    'no': {
        'en': 'No',
        'ar': 'لا',
        'ht': 'Non',
        'pl': 'NIE',
        'pt': 'Não',
        'sr': 'Не',
        'es': 'No',
        'vi': 'KHÔNG',
        'zh': '不',
        'ne': 'छैन'
    },
    'insurance-photo-choice': {
        'en': <p className='text-justify  text-[#333] text-sm leading-5'>We need Images of your <b>insurance card</b>. Would you like to <b className='text-primary'>Upload</b> Images stored on your device or 
            <b className='text-primary'> Take a Photo</b> of your card(s) using your device?</p>,
        'ar': <p className='dir-rtl  text-[#333] text-sm leading-5'>نحتاج إلى صور <b>بطاقة التأمين</b> الخاصة بك. هل ترغب في <b className='text-primary'>تحميل</b> الصور المخزنة على جهازك أم
            <b className='text-primary'> التقط صورة</b> لبطاقتك (بطاقاتك) باستخدام جهازك؟</p>,
        'ht': <p className='text-justify  text-[#333] text-sm leading-5'>Nou bezwen imaj <b>kat asirans ou</b>. Èske ou ta renmen <b className='text-primary'>Télécharger</b> Imaj ki estoke sou aparèy ou an oswa
            <b className='text-primary'> Pran yon foto</b> kat ou (yo) lè l sèvi avèk aparèy ou a?</p>,
        'pl': <p className='text-justify  text-[#333] text-sm leading-5'>Potrzebujemy zdjęć Twojej <b>karty ubezpieczeniowej</b>. Czy chcesz <b className='text-primary'>przesłać</b> obrazy zapisane na Twoim urządzeniu lub
            <b className='text-primary'> Zrobić zdjęcie</b> swoich kart za pomocą urządzenia?</p>,
        'pt': <p className='text-justify  text-[#333] text-sm leading-5'>Precisamos de imagens do seu <b>cartão de seguro</b>. Gostaria de <b className='text-primary'>fazer upload</b> de imagens armazenadas em seu dispositivo ou
            <b className='text-primary'>Tirar uma foto</b> do(s) seu(s) cartão(ões) usando seu dispositivo?</p>,
        'sr': <p className='text-justify  text-[#333] text-sm leading-5'>Потребне су нам слике ваше <b>картице осигурања</b>. Да ли желите да <b className='text-primary'>отпремите</b> слике сачуване на вашем уређају или
            <b className='text-primary'> Снимите фотографију</b> своје картице помоћу уређаја?</p>,
        'es': <p className='text-justify  text-[#333] text-sm leading-5'>Necesitamos imágenes de su <b>tarjeta de seguro</b>. ¿Le gustaría <b className='text-primary'>Subir</b> imágenes almacenadas en su dispositivo o
            <b className='text-primary'> ¿Tomar una foto</b> de su(s) tarjeta(s) usando su dispositivo?</p>,
        'vi': <p className='text-justify  text-[#333] text-sm leading-5'>Chúng tôi cần Hình ảnh <b>thẻ bảo hiểm</b> của bạn. Bạn có muốn <b className='text-primary'>Tải lên</b> Hình ảnh được lưu trữ trên thiết bị của bạn hoặc
            <b className='text-primary'> Chụp ảnh</b> thẻ của bạn bằng thiết bị của bạn?</p>,
        'zh': <p className='text-justify  text-[#333] text-sm leading-5'>我们需要您的<b>保险卡的图片</b>。您想要<b className='text-primary'>上传</b>您设备上存储的图像吗？
            使用您的设备<b className='text-primary'>拍摄您的卡的照片</b>？</p>,
        'ne': <p className='text-justify  text-[#333] text-sm leading-5'>हामीलाई तपाईंको <b>बीमा कार्ड</b> को छविहरू चाहिन्छ। के तपाईं आफ्नो यन्त्रमा भण्डारण गरिएका छविहरू <b className='text-primary'>अपलोड</b> गर्न चाहनुहुन्छ वा
            आफ्नो यन्त्र प्रयोग गरेर आफ्नो कार्ड(हरू) को <b className='text-primary'> फोटो खिच्नुहोस्</b>?</p>
    },
    'insurance-front-upload': {
        'en': <p className='text-center text-[#333] text-sm leading-5'>Select <b>Insurance card</b> <b className='text-primary'>FRONT</b> image to upload.</p>  ,
        'ar': <p className='dir-rtl text-[#333] text-sm leading-5'>حدد <b>بطاقة التأمين</b> <b className='text-primary'>الأمامية</b> لتحميل الصورة.</p>,
        'ht': <p className='text-center text-[#333] text-sm leading-5'>Chwazi <b>Kat Asirans</b> <b className='text-primary'>DEVAN</b> imaj pou w telechaje.</p>,
        'pl': <p className='text-center text-[#333] text-sm leading-5'>Wybierz obraz <b>Karta ubezpieczeniowa</b> <b className='text-primary'>PRZEDNI</b> do przesłania.</p>,
        'pt': <p className='text-center text-[#333] text-sm leading-5'>Selecione a imagem do <b>cartão de seguro</b> <b className='text-primary'>Frente</b> para fazer upload.</p>,
        'sr': <p className='text-center text-[#333] text-sm leading-5'>Изаберите <b>картицу осигурања</b> <b className='text-primary'>ПРЕДЊА</b> слику за отпремање.</p>,
        'es': <p className='text-center text-[#333] text-sm leading-5'>Seleccione la imagen <b>Tarjeta de seguro</b> <b className='text-primary'>Delantero</b> para cargar.</p>,
        'vi': <p className='text-center text-[#333] text-sm leading-5'>Chọn hình ảnh <b>Thẻ bảo hiểm</b> <b className='text-primary'>TRƯỚC</b> để tải lên.</p>,
        'zh': <p className='text-center text-[#333] text-sm leading-5'>选择要上传的<b>保险卡</b><b className='text-primary'>正面</b>图像。</p>,
        'ne': <p className='text-center text-[#333] text-sm leading-5'>अपलोड गर्न <b>बीमा कार्ड</b> <b className='text-primary'>अगाडि</b> छवि चयन गर्नुहोस्।</p>
    },
    'insurance-back-upload': {
        'en': <p className='text-center text-[#333] text-sm leading-5'>Select <b>Insurance card</b> <b className='text-primary'>BACK</b> image to upload.</p>  ,
        'ar': <p className='dir-rtl text-[#333] text-sm leading-5'>حدد <b>بطاقة التأمين</b> <b className='text-primary'>خلف</b> لتحميل الصورة.</p>,
        'ht': <p className='text-center text-[#333] text-sm leading-5'>Chwazi <b>Kat Asirans</b> <b className='text-primary'>Retounen</b> imaj pou w telechaje.</p>,
        'pl': <p className='text-center text-[#333] text-sm leading-5'>Wybierz obraz <b>Karta ubezpieczeniowa</b> <b className='text-primary'>Z powrotem</b> do przesłania.</p>,
        'pt': <p className='text-center text-[#333] text-sm leading-5'>Selecione a imagem do <b>cartão de seguro</b> <b className='text-primary'>Voltar</b> para fazer upload.</p>,
        'sr': <p className='text-center text-[#333] text-sm leading-5'>Изаберите <b>картицу осигурања</b> <b className='text-primary'>Назад</b> слику за отпремање.</p>,
        'es': <p className='text-center text-[#333] text-sm leading-5'>Seleccione la imagen <b>Tarjeta de seguro</b> <b className='text-primary'>Atrás</b> para cargar.</p>,
        'vi': <p className='text-center text-[#333] text-sm leading-5'>Chọn hình ảnh <b>Thẻ bảo hiểm</b> <b className='text-primary'>Mặt sau</b> để tải lên.</p>,
        'zh': <p className='text-center text-[#333] text-sm leading-5'>选择要上传的<b>保险卡</b><b className='text-primary'>后退</b>图像。</p>,
        'ne': <p className='text-center text-[#333] text-sm leading-5'>अपलोड गर्न <b>बीमा कार्ड</b> <b className='text-primary'>पछाडि</b> छवि चयन गर्नुहोस्।</p>
    },
    'front': {
        'en': 'Front',
        'ar': 'أمام',
        'ht': 'DEVAN',
        'pl': 'PRZÓD',
        'pt': 'FRENTE',
        'sr': 'ФРОНТ',
        'es': 'Delantero',
        'vi': 'ĐẰNG TRƯỚC',
        'zh': '正面',
        'ne': 'अगाडि'
    },
    'browse': {
        'en': 'Browse',
        'ar': 'تصفح',
        'ht': 'Browse',
        'pl': 'Przeglądać',
        'pt': 'Navegar',
        'sr': 'Прегледај',
        'es': 'Navegar',
        'vi': 'Duyệt qua',
        'zh': '浏览',
        'ne': 'ब्राउज गर्नुहोस्'
    },
    'file-format': {
        'en': 'File Format: JPEG/PNG; Max Size: 5MB',
        'ar': 'تنسيق الملف: جبيغ/بينغ؛ الحد الأقصى للحجم: 5 ميجابايت',
        'ht': 'Fòma fichye: JPEG/PNG; Gwosè maksimòm: 5MB',
        'pl': 'Format pliku: JPEG/PNG; Maksymalny rozmiar: 5MB',
        'pt': 'Formato de arquivo: JPEG/PNG; Tamanho máximo: 5 MB',
        'sr': 'Формат датотеке: ЈПЕГ/ПНГ; Максимална величина: 5МБ',
        'es': 'Formato de archivo: JPEG/PNG; Tamaño máximo: 5 MB',
        'vi': 'Định dạng tệp: JPEG/PNG; Kích thước tối đa: 5 MB',
        'zh': '文件格式：JPEG/PNG；最大大小：5MB',
        'ne': 'फाइल ढाँचा: JPEG/PNG; अधिकतम आकार: 5MB'
    },
    'insurance-detail-info': {
        'en': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Please verify the <b>Data</b> captured was correct. You can select the <b>Fields</b> below to <b>Edit</b> them. 
            Press <b className='text-primary'>Next</b> when ready to continue or <b className='text-primary'>Back</b> to upload another image.</p>,
        'ar': <p className='font-normal text-sm text-[#333] dir-rtl break-words my-[18px]'>يُرجى التحقق من صحة <b>البيانات</b> التي تم التقاطها. يمكنك تحديد <b>الحقول</b> أدناه <b>لتحريرها</b> منها.
            اضغط على <b className='text-primary'>التالي</b> عندما تكون مستعدًا للمتابعة أو على <b className='text-primary'>رجوع</b> لتحميل صورة أخرى.</p>,
        'ht': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Tanpri verifye <b>Done</b> yo te pran yo te kòrèk. Ou ka chwazi <b>Jaden</b> ki anba yo pou <b>Edite</b> yo.
            Peze <b className='text-primary'>Next</b> lè w pare pou kontinye oswa <b className='text-primary'>Retounen</b> pou telechaje yon lòt imaj.</p>,
        'pl': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Sprawdź, czy przechwycone <b>dane</b> są prawidłowe. Możesz wybrać <b>pola</b> poniżej, aby je <b>edytować</b>.
            Naciśnij <b className='text-primary'>Dalej</b>, aby kontynuować, lub <b className='text-primary'>Wstecz</b>, aby przesłać kolejny obraz.</p>,
        'pt': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Verifique se os <b>dados</b> capturados estão corretos. Você pode selecionar os <b>Campos</b> abaixo para <b>Editá-los</b>.
            Pressione <b className='text-primary'>Avançar</b> quando estiver pronto para continuar ou <b className='text-primary'>Voltar</b> para fazer upload de outra imagem.</p>,
        'sr': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Молимо проверите да су <b>Подаци</b> ухваћени тачни. Можете да изаберете <b>Поља</b> у наставку да бисте их <b>изменили</b>.
            Притисните <b className='text-primary'>Даље</b> када сте спремни да наставите или <b className='text-primary'>Назад</b> да бисте отпремили другу слику.</p>,
        'es': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Verifique que los <b>datos</b> capturados sean correctos. Puede seleccionar los <b>Campos</b> a continuación para <b>Editarlos</b>.
            Presione <b className='text-primary'>Siguiente</b> cuando esté listo para continuar o <b className='text-primary'>Atrás</b> para cargar otra imagen.</p>,
        'vi': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>Vui lòng xác minh <b>Dữ liệu</b> được thu thập là chính xác. Bạn có thể chọn <b>Trường</b> bên dưới để <b>Chỉnh sửa</b> chúng.
            Nhấn <b className='text-primary'>Tiếp theo</b> khi sẵn sàng tiếp tục hoặc <b className='text-primary'>Quay lại</b> để tải lên hình ảnh khác.</p>,
        'zh': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>请验证捕获的<b>数据</b>是否正确。您可以选择下面的<b>字段</b>来<b>编辑</b>它们。
            准备好继续时按<b className='text-primary'>下一步</b>，或按<b className='text-primary'>后退</b>上传另一张图像。</p>,
        'ne': <p className='font-normal text-sm text-[#333] text-justify break-words my-[18px]'>कृपया क्याप्चर गरिएको <b>डेटा</b> सही थियो भनी प्रमाणित गर्नुहोस्। तपाईंले तिनीहरूलाई <b>सम्पादन</b> गर्न तल <b>क्षेत्रहरू</b> चयन गर्न सक्नुहुन्छ।
            जारी राख्न तयार हुँदा <b className='text-primary'>अर्को</b> थिच्नुहोस् वा अर्को छवि अपलोड गर्न <b className='text-primary'>पछाडि</b> थिच्नुहोस्।</p>
    },
    'insurance-carrier': {
        'en': 'Insurance Carrier',
        'ar': 'الناقل التأمين',
        'ht': 'Konpayi asirans',
        'pl': 'Przewoźnik ubezpieczeniowy',
        'pt': 'Seguradora',
        'sr': 'Носилац осигурања',
        'es': 'Aseguradora',
        'vi': 'Hãng bảo hiểm',
        'zh': '保险公司',
        'ne': 'बीमा वाहक'
    },
    'policy-holder-name': {
        'en': 'Policy Holder Name',
        'ar': 'إسم صاحب الوثيقة',
        'ht': 'Non moun ki gen règleman yo',
        'pl': 'Imię i nazwisko ubezpieczającego',
        'pt': 'Nome do titular da apólice',
        'sr': 'Име носиоца полисе',
        'es': 'Nombre del titular de la póliza',
        'vi': 'Tên chủ hợp đồng',
        'zh': '保单持有人姓名',
        'ne': 'नीति धारकको नाम'
    },
    'member-id': {
        'en': 'Member ID / Policy #',
        'ar': 'معرف العضو / رقم السياسة',
        'ht': 'ID manm / Règleman #',
        'pl': 'Numer identyfikacyjny członka/polityki #',
        'pt': 'ID do membro/Política #',
        'sr': 'ИД члана/смерница бр.',
        'es': 'ID de miembro/n.º de póliza',
        'vi': 'ID thành viên / Chính sách #',
        'zh': '会员 ID/政策#',
        'ne': 'सदस्य आईडी / नीति #'
    },
    'take-front-photo': {
        'en': <p className='text-justify text-[#333] text-sm leading-5'>Take a Photo of the <b className='text-primary'> FRONT</b> of your insurance card by touching the button below.</p>,
        'ar': <p className='dir-rtl text-[#333] text-sm leading-5'>التقط صورة <b className='text-primary'> الجزء الأمامي</b> من بطاقة التأمين الخاصة بك عن طريق لمس الزر أدناه.</p>,
        'ht': <p className='text-justify text-[#333] text-sm leading-5'>Pran yon foto <b className='text-primary'> DEVAN</b> kat asirans ou lè w touche bouton ki anba a.</p>,
        'pl': <p className='text-justify text-[#333] text-sm leading-5'>Zrób zdjęcie <b className='text-primary'> PRZÓDU</b> swojej karty ubezpieczeniowej, dotykając przycisku poniżej.</p>,
        'pt': <p className='text-justify text-[#333] text-sm leading-5'>Tire uma foto da <b className='text-primary'> FRENTE</b> do seu cartão de seguro tocando no botão abaixo.</p>,
        'sr': <p className='text-justify text-[#333] text-sm leading-5'>Снимите слику <b className='text-primary'> ПРЕДЊЕГ дела</b> своје картице осигурања тако што ћете додирнути дугме испод.</p>,
        'es': <p className='text-justify text-[#333] text-sm leading-5'>Tome una foto del <b className='text-primary'> Delantero</b> de su tarjeta de seguro tocando el botón a continuación.</p>,
        'vi': <p className='text-justify text-[#333] text-sm leading-5'>Chụp ảnh <b className='text-primary'> Mặt trước</b> thẻ bảo hiểm của bạn bằng cách chạm vào nút bên dưới.</p>,
        'zh': <p className='text-justify text-[#333] text-sm leading-5'>触摸下面的按钮，拍摄保险卡<b className='text-primary'> 正面</b>的照片。</p>,
        'ne': <p className='text-justify text-[#333] text-sm leading-5'>तलको बटन छोएर आफ्नो बीमा कार्डको <b className='text-primary'> अगाडि</b> फोटो खिच्नुहोस्।</p>
    },
    'take-back-photo': {
        'en': <p className='text-justify text-[#333] text-sm leading-5'>Take a Photo of the <b className='text-primary'> BACK</b> of your insurance card by touching the button below.</p>,
        'ar': <p className='dir-rtl text-[#333] text-sm leading-5'>التقط صورة <b className='text-primary'> خلف</b> من بطاقة التأمين الخاصة بك عن طريق لمس الزر أدناه.</p>,
        'ht': <p className='text-justify text-[#333] text-sm leading-5'>Pran yon foto <b className='text-primary'> Retounen</b> kat asirans ou lè w touche bouton ki anba a.</p>,
        'pl': <p className='text-justify text-[#333] text-sm leading-5'>Zrób zdjęcie <b className='text-primary'> Z powrotem</b> swojej karty ubezpieczeniowej, dotykając przycisku poniżej.</p>,
        'pt': <p className='text-justify text-[#333] text-sm leading-5'>Tire uma foto da <b className='text-primary'> Voltar</b> do seu cartão de seguro tocando no botão abaixo.</p>,
        'sr': <p className='text-justify text-[#333] text-sm leading-5'>Снимите слику <b className='text-primary'> Назад</b> своје картице осигурања тако што ћете додирнути дугме испод.</p>,
        'es': <p className='text-justify text-[#333] text-sm leading-5'>Tome una foto del <b className='text-primary'> Atrás</b> de su tarjeta de seguro tocando el botón a continuación.</p>,
        'vi': <p className='text-justify text-[#333] text-sm leading-5'>Chụp ảnh <b className='text-primary'> Mặt sau</b> thẻ bảo hiểm của bạn bằng cách chạm vào nút bên dưới.</p>,
        'zh': <p className='text-justify text-[#333] text-sm leading-5'>触摸下面的按钮，拍摄保险卡<b className='text-primary'> 后退</b>的照片。</p>,
        'ne': <p className='text-justify text-[#333] text-sm leading-5'>तलको बटन छोएर आफ्नो बीमा कार्डको <b className='text-primary'> पछाडि</b> फोटो खिच्नुहोस्।</p>
    },
    'take-photo': {
        'en': 'Take a photo',
        'ar': 'التقاط صورة',
        'ht': 'Pran yon foto',
        'pl': 'Robić zdjęcie',
        'pt': 'Tire uma foto',
        'sr': 'Сликати',
        'es': 'Toma una foto',
        'vi': 'Chụp ảnh',
        'zh': '拍个照',
        'ne': 'फोटो खिच्नुहोस्'
    },
    're-take-photo': {
        'en': 'Re-take Photo',
        'ar': 'إعادة التقاط الصورة',
        'ht': 'Re-pran foto',
        'pl': 'Zrób zdjęcie ponownie',
        'pt': 'Retirar foto',
        'sr': 'Поново снимите фотографију',
        'es': 'Volver a tomar la foto',
        'vi': 'Chụp lại ảnh',
        'zh': '重新拍照',
        'ne': 'फोटो पुन: लिनुहोस्'
    },
    'expiration-date': {
        'en': 'Expiration Date',
        'ar': 'تاريخ انتهاء الصلاحية',
        'ht': 'Dat ekspirasyon',
        'pl': 'Termin ważności',
        'pt': 'Data de validade',
        'sr': 'Рок трајања',
        'es': 'Fecha de caducidad',
        'vi': 'Ngày hết hạn',
        'zh': '截止日期',
        'ne': 'म्याद समाप्त हुने मिति'
    },
    "Enter policy holder name": {
        'en': 'Enter policy holder name',
        'ar': 'أدخل اسم صاحب السياسة',
        'ht': 'Antre non detantè politik la',
        'pl': 'Wprowadź imię i nazwisko ubezpieczającego',
        'pt': 'Insira o nome do titular da apólice',
        'sr': 'Унесите име носиоца полисе',
        'es': 'Introduzca el nombre del titular de la póliza',
        'vi': 'Nhập tên chủ hợp đồng',
        'zh': '输入保单持有人姓名',
        'ne': 'नीति धारकको नाम प्रविष्ट गर्नुहोस्'
    },
    'Search and select insurance carrier': {
        'en': 'Search and select insurance carrier',
        'ar':  'بحث واختيار شركة التأمين',
        'ht': 'Wyszukaj i wybierz ubezpieczyciela',
        'pl': 'Wyszukaj i wybierz ubezpieczyciela',
        'pt': 'Pesquise e selecione seguradora',
        'sr': 'Потражите и изаберите носиоца осигурања',
        'es': 'Buscar y seleccionar compañía de seguros',
        'vi': 'Tìm kiếm và lựa chọn hãng bảo hiểm',
        'zh': '搜索并选择保险公司',
        'ne': 'खोज्नुहोस् र बीमा वाहक चयन गर्नुहोस्'
    }
}